// 导入vue-i18n插件
import { createI18n } from "vue-i18n";

// ElementPlus自带的国际化配置文件 支持多种语音 与我们自己定义的无关
import el_zh_cn from "element-plus/lib/locale/lang/zh-cn";
import el_en from "element-plus/lib/locale/lang/en";

// 这是我们自己的国际化配置文件
import zh_cn from "./lang/zh-cn";
import en from "./lang/en";

const messages = {
  // 中文的翻译文件
  "zh-CN": {
    el: el_zh_cn, //element-plus的国际化
    ...zh_cn, //自己的国际化
  },
  // 英语的翻译
  "en-US": {
    el: el_en,
    ...en,
  },
};
// 通过选项创建 VueI18n 实例
const i18n = createI18n({
  // 本地默认使用语音
  locale: localStorage.getItem(process.env.VUE_APP_LANG_NAME) || "zh-CN",
  // 失败使用语言环境
  fallbackLocale: "zh-CN",
  // 全局注入
  globalInjection: true,
  // 兼容element-plus国际化
  legacy: false, //Uncaught SyntaxError: Not available in legacy mode翻译：“未捕获的语法：在旧模式中不可用”解决方法：在 createI18n 添加：legacy: false,
  //
  messages,
});

export default i18n;
